var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQpointinline = function SvgQpointinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 90 72"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qpoint_inline_svg__a",
    d: "M0 0h9.637v9.585H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qpoint_inline_svg__c",
    d: "M0 0h70.048v69.67H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.363 62.415)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qpoint_inline_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qpoint_inline_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#101417",
    d: "M6.658 9.585c-.76 0-1.524-.29-2.108-.868L.874 5.057a2.948 2.948 0 0 1 0-4.19 2.993 2.993 0 0 1 4.213 0l3.68 3.66a2.954 2.954 0 0 1 0 4.19 2.995 2.995 0 0 1-2.109.868",
    mask: "url(#qpoint_inline_svg__b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "qpoint_inline_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qpoint_inline_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#101417",
    d: "M51.655 51.765a2.954 2.954 0 0 0 0-4.19L40 35.977a2.997 2.997 0 0 0-4.216 0 2.959 2.959 0 0 0 0 4.194l11.659 11.593a2.98 2.98 0 0 0 2.104.868c.764 0 1.527-.29 2.108-.868m18.393-16.928c0 19.239-15.682 34.833-35.024 34.833C15.68 69.67-.001 54.076-.001 34.837 0 15.597 15.681 0 35.024 0c19.342 0 35.024 15.597 35.024 34.837",
    mask: "url(#qpoint_inline_svg__d)"
  })))));
};
export default SvgQpointinline;